import { render, staticRenderFns } from "./InternalPublications.vue?vue&type=template&id=267e2f50&"
import script from "./InternalPublications.vue?vue&type=script&lang=js&"
export * from "./InternalPublications.vue?vue&type=script&lang=js&"
import style0 from "./InternalPublications.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports